import React from 'react'

import { COACH_APPLY_PATH } from '@/lib/constants/routes'
import { cn } from '@/lib/utils'
import { useIsCoach } from '@/hooks/useAuthSession'
import { useUserContext } from '@/hooks/user'

import { AppContext } from '@/components/base/appcontext'
import { CAROUSEL_CARD } from '@/components/base/carouselRow'
import LinkWithState from '@/components/base/link'
import UserAvatar from '@/components/base/userAvatar'

import { Badge } from '@/components/ui/badge'
import { Typography } from '@/components/ui/typography'

// The viewer's own card at the end of the coaches row: a coach card in
// inverted colors that opens the coach application. Hidden for coaches.
const VacantSeatCard: React.FC = () => {
    const appContext = React.useContext(AppContext)
    const { user } = useUserContext()
    if (useIsCoach()) return null

    return (
        <li className={cn(CAROUSEL_CARD, 'bg-foreground text-background')}>
            <LinkWithState
                to={COACH_APPLY_PATH}
                className="flex items-start gap-2.5 p-3 active:scale-[0.98]"
            >
                <UserAvatar
                    name={user?.username}
                    photo={user?.photo_url}
                    coach
                    className="h-9 w-9 shrink-0 ring-offset-foreground"
                    fallbackClassName="text-xs font-semibold text-foreground"
                />
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5">
                        <Typography
                            variant="title-sm"
                            className="leading-tight truncate"
                        >
                            {appContext.geti18n('homepage.coachCta.seat.title')}
                        </Typography>
                        <Badge variant="coach" size="xs">
                            {appContext.geti18n('homepage.coachCta.apply')}
                        </Badge>
                    </div>
                    <Typography
                        variant="body-xs"
                        className="leading-tight truncate text-background/70"
                    >
                        {appContext.geti18n('homepage.coachCta.subtitle')}
                    </Typography>
                </div>
            </LinkWithState>
        </li>
    )
}

export default VacantSeatCard
